import React, { useState, useEffect, useRef } from 'react';
import logo from "../../assets/images/logo.png";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Getdata } from '../../helpers/api.service';

const Navbar = (props) => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    
    // Reference to the navbar menu to check clicks outside
    const menuRef = useRef(null);
    const toggleRef = useRef(null);

    let tabs = [
        { name: "Home", path: "/" },
        { name: "About Us", path: "/about" },
        { name: "Education", path: "/education" },
        { name: "Admission", path: "/admission-details" },
        { name: "News", path: "/news" },
    ];

    // Close the menu if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && !toggleRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        // Add event listener on component mount
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Full page loader if data is not loaded yet
    if (!props.data) {
        return (
            <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[2000]">
                <div className="w-16 h-16 border-8 border-gray-300 border-t-primary_main rounded-full animate-spin"></div>
            </div>
        );
    }

    // Function to handle navigation and close the menu
    const handleNavigation = (path) => {
        navigate(path);
        setOpen(false); // Close the menu after navigation
    };

    return (
        <nav className="w-full bg-[#EEF0F2] fixed top-0 z-[999] ">
            <div className="container mx-auto flex items-center justify-between py-4 px-4 md:px-10">
                {/* Logo  */}
                <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate("/")}>
                    <div className="w-20 h-20 flex items-center justify-center relative">
                        <img
                            src={props.data?.logo || logo}
                            alt="logo"
                            className="w-20 h-20 object-contain transition-opacity duration-300"
                        />
                    </div>
                    <span className="text-2xl font-bold mt-2">{props.data?.name}</span>
                </div>

                {/* Hamburger Menu */}
                <div
                    className="md:hidden cursor-pointer"
                    onClick={() => setOpen(!open)}
                    ref={toggleRef}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-8 h-8"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3.75 5.25h16.5m-16.5 6h16.5m-16.5 6h16.5"
                        />
                    </svg>
                </div>

                {/* Navigation Links */}
                <ul
                    className={`md:flex md:items-center md:static absolute w-full left-0 md:w-auto md:bg-transparent bg-[#F4F5F7] transition-all duration-700 ease-in ${open ? 'top-28 opacity-100 py-5 px-4' : 'top-[-400px]'}`}
                    ref={menuRef}
                >
                    {tabs.map((item) => (
                        <li key={item.name} className="my-2 md:my-0 cursor-pointer py-2 px-4 text-base">
                            <Link
                                to={item.path}
                                onClick={() => handleNavigation(item.path)} // Close the menu on click
                                className={`hover:text-primary_main text-f15 ${
                                    location.pathname === item.path ? 'text-primary_main font-bold' : ''
                                }`}
                            >
                                {item.name}
                            </Link>
                        </li>
                    ))}
                    <li classNamse="my-2 md:my-0">
                        <button
                            className="bg-secondary_main text-white px-2 py-2 rounded-md font-bold text-base"
                            onClick={() => { navigate("/contact"); setOpen(false); }} // Close the menu after navigating
                        >
                            Contact Us
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
